<div class="w-full text-center border border-bottom py-3">
  <i class="ico-Close float-right font-bold text-lg" (click)="closeSort()"></i>
  <h3 class="">مرتب سازی</h3>
</div>
<ng-container *ngIf=" accommodation() != 'ecolodge'">
  <mat-selection-list class=" px-0">
    <mat-list-item class="border-bottom " (click)="checkedItem(item.id,accommodation())"
      *ngFor="let item of checklist;let index = index">
      <span class="text-sm {{item.isSelected ? 'text-blue-500' : ''}}">{{item.value}}</span>
      <span class="float-left {{item.isSelected ? 'text-blue-500' : ''}}" *ngIf="item.isSelected">&#10003;</span>
    </mat-list-item>
  </mat-selection-list>
</ng-container>
<ng-container *ngIf="accommodation() == 'ecolodge'">
  <mat-selection-list class="px-0">
    <mat-list-item class="border-bottom " (click)="checkedItem(item.id,accommodation())"
    *ngFor="let item of checklistEcologe;let index = index">
      <span class="text-sm" [ngClass]="item.isSelected ? 'text-blue-500' : ''">{{item.value}}</span>
      <span class="float-left {{item.isSelected ? 'text-blue-500' : ''}}" *ngIf="item.isSelected">&#10003;</span>
    </mat-list-item>
  </mat-selection-list>
</ng-container>